import React from "react";
import Card from "../../shared/state-components/Card";

const TransporterAlias = props => {
  const alias = props.alias.map((alias, i) => (
    <div key={i}>
      {i + 1}. {alias.TRANS_AKA}
    </div>
  ));
  return (
    <Card
      cardType="default"
      cardHeader="Alias"
      headerColor="#046B99"
      headerTextColor="white"
      cardBody=""
      cardColor="white"
    >
      <div className="facility-address-card">
        {alias.length == 0 ? <div>No Alias</div> : <div>{alias}</div>}
      </div>
    </Card>
  );
};

export default TransporterAlias;
